import { useAuthQuery } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';
import { EventScheduleApi } from 'api';

function useGet(eventId: number) {
  return useAuthQuery(
    getQueryKeys([KEY]).detail(eventId),
    () => EventScheduleApi.get(eventId),
    {
      select: (data) => data.data,
      enabled: !!eventId,
    },
  );
}

export default useGet;
